import { render, staticRenderFns } from "./SectionOfLogos.vue?vue&type=template&id=2a2d5790&scoped=true"
import script from "./SectionOfLogos.vue?vue&type=script&lang=js"
export * from "./SectionOfLogos.vue?vue&type=script&lang=js"
import style0 from "./SectionOfLogos.vue?vue&type=style&index=0&id=2a2d5790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d5790",
  null
  
)

export default component.exports